// css
import "stylesheets/packs/desktop/live.scss";

// JS
// Must Have
import "regenerator-runtime/runtime";
import "jquery";
import "lazysizes";
import Rails from "rails-ujs";
Rails.start();

// vendor
import "vendor/bootstrap-sass/assets/javascripts/bootstrap/transition"; // obscure usage: emulateTransitionEnd
import "javascripts/jquery.prompt";
import "javascripts/jquery.transit";
import "javascripts/typeahead.jquery";
import "javascripts/slick";
import "bootstrap/js/dropdown";
import "bootstrap/js/modal";
import "bootstrap/js/tab";

// global objects
window.AhoyPageviewEvent = require("shared/ahoy_pageview_event").default;
window.BannerAdTracker = require("components/shared/BannerAdTracker/BannerAdTracker").default; // needed by gpt_tracker
window.GoogleOneTapTracker = require("components/shared/GoogleOneTapTracker/GoogleOneTapTracker").default;
window.LoginOfferingHelper = require("shared/components/login_offering_helper").default;

// components
window.FlashNotification = require("desktop/components/flash_notification").default;
window.UserTranscodeNotification = require("desktop/components/user_transcode_notification").default;
window.TransparentHeaderAtTop = require("desktop/components/transparent_header_at_top").default;
window.KidsHeader = require("components/desktop/KidsHeader/KidsHeader").default;
window.SearchSuggestion = require("desktop/components/search_suggestion").default;
window.BackToTop = require("desktop/components/back_to_top").default;
window.EmbedPopup = require("desktop/components/embed_popup").default;
window.AddToCollectionPopup = require("desktop/components/add_to_collection_popup").default;
window.Topic = require("shared/topic").default; // move to load_playback after permanent feature_toggle
window.CommentForm = require("desktop/components/comment_form").default;
window.CarouselLivestreaming = require("shared/components/carousel_livestreaming").default;
window.WebSocketConnection = require("shared/components/live/web_socket_connection").default;
window.PremiumBannerBenefitToggle = require("desktop/components/premium_banner_benefit_toggle").default;
window.LivestreamingTitle = require("components/shared/LivestreamingTitle/LivestreamingTitle").default;
window.LivestreamingDetail = require("desktop/components/livestreaming_detail").default;
window.LivestreamingScheduleDatePicker = require("desktop/components/livestreaming_schedule_date_picker").default;
window.LivestreamingPresenceTracker = require("shared/components/plenty_tracker/livestreaming_presence_tracker").default;
window.LivestreamingCountdown = require("components/shared/LivestreamingCountdown/LivestreamingCountdown").default;
window.UpdateRecentLivestreaming = require("components/shared/UpdateRecentLivestreaming/UpdateRecentLivestreaming").default;
window.Stickerify = require("shared/stickerify").default;
window.EmojiTable = require("desktop/components/emoji_table").default;
window.DesktopLivestreamingBanner = require("desktop/components/livestreaming_banner").default;
window.CurrentWatchExcluder = require("shared/components/livestreaming/current_watch_excluder").default;
window.Kmklabs = require("components/shared/Kmklabs/Kmklabs").default;
window.Autolink = require("components/shared/Autolink/Autolink").default;
window.ScheduleRetriever = require("shared/components/livestreaming/schedule_retriever").default;
window.ConcurrentUsers = require("shared/components/concurrent_users").default;
window.PremiumSubscribeModal = require("desktop/components/premium_subscribe_modal").default;
window.MuxLoader = require('components/shared/MuxLoader/MuxLoader').default;

// recommendation
window.LivestreamingRelated = require("components/shared/LivestreamingRelated/LivestreamingRelated").default;

import GtmLivestreamings from "desktop/initializers/gtm_livestreamings";
import ShowMoreContent from "shared/show_more_content";
import Pip from "desktop/components/pip";
import MoreNav from "desktop/more_nav";

// auth
import { ApiKey } from "commons/ApiKey";

// react component
import { PopupBottomSheet } from "components/desktop/PopupBottomSheet";
window.PopupBottomSheet = PopupBottomSheet;

// initializers
import ComponentInitializers from "components/shared/ComponentInitializers/ComponentInitializers";
import InteractionStatus from "desktop/initializers/interaction_status";

import { ComponentObserver } from "components/shared/ComponentObserver/ComponentObserver";

$(document).ready(function () {
  const jsComponent = document.querySelectorAll(".js-component");
  new ComponentObserver().observe(jsComponent);
  new ComponentInitializers();
  InteractionStatus.init();
  GtmLivestreamings.init();
  MoreNav.init_new($(".header-category__items"), ".header-category");

  ApiKey.getApiKey().finally(() => {
    ComponentInitializers.initJsApiComponent();
  });
});

$(window).on("load", function () {
  new ShowMoreContent(
    ".article-desc",
    ".partial-desc .read-more",
    ".full-desc"
  ); // description

  $("#new_comment").on("ajax:send", function () {
    $(this).find("#comment_content").prop("disabled", true);
    $(this).find("button[type='submit']").prop("disabled", true);
    $(this).find("#comment_content").css("background-color", "#ddd");
  });

  $("#new_comment").on("ajax:complete", function () {
    var that = $(this);
    that.find("#comment_content").prop("disabled", false);
    that.find("button[type='submit']").prop("disabled", false);
    that.find("#comment_content").css("background-color", "#fff");
    that.find("#comment_content").focus();
  });

  new Pip().init();
});
